var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67285 6.08043C8.43372 6.52022 9.38431 5.97146 9.38431 5.09286C9.38431 3.93697 10.3213 3 11.4772 3H12.9853C14.1412 3 15.0781 3.93697 15.0781 5.09286C15.0781 5.97146 16.0297 6.52022 16.7896 6.08043C17.7898 5.50249 19.0703 5.84595 19.6482 6.84714L20.4023 8.15286C20.9802 9.15405 20.6358 10.4335 19.6356 11.0115C18.8757 11.4512 18.8757 12.5488 19.6356 12.9876C20.6367 13.5655 20.9802 14.8459 20.4023 15.8462L19.6482 17.1529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81422 6.84766L4.06016 8.15339C3.48222 9.15458 3.82471 10.434 4.82589 11.012C5.58676 11.4518 5.58676 12.5493 4.82589 12.9881C3.82471 13.566 3.48222 14.8465 4.06016 15.8467L4.81422 17.1534C5.39216 18.1546 6.67162 18.4971 7.67281 17.9191C8.43368 17.4803 9.38427 18.0291 9.38427 18.9067C9.38427 20.0626 10.3212 21.0005 11.4771 21.0005H12.9852C14.1411 21.0005 15.0781 20.0626 15.0781 18.9067C15.0781 18.0291 16.0287 17.4803 16.7886 17.9191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4431 11.9999C15.4431 13.7746 14.005 15.2126 12.2303 15.2126C10.4556 15.2126 9.01758 13.7746 9.01758 11.9999C9.01758 10.2252 10.4556 8.78711 12.2303 8.78711C12.987 8.78711 13.6824 9.0485 14.2313 9.48593",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.98152c68881bf174db206576e2fef8f6.svg";
export { ForwardRef as ReactComponent };